define('fukit/view/block/label.component.view',['require','exports','module','backbone','marionette','uikit/uikit','../../helpers/extend.util','../../behavior/bind.and.format.option.values.behavior','../../helpers/formatter','underscore','../../templates','handlebars'],function(require, exports, module) {
  //prettier-ignore
  var Backbone                          = require('backbone'),
      Mn                                = require('marionette'),
      UIKit                             = require('uikit/uikit'),
      ExtendUtil                        = require('../../helpers/extend.util'),
      BindAndFormatOptionValuesBehavior = require('../../behavior/bind.and.format.option.values.behavior'),
      Formatter                         = require('../../helpers/formatter'),
      _                                 = require('underscore'),
      Templates                         = require('../../templates'),
      Handlebars                        = require('handlebars');

  var ErrorStateModel = Backbone.Model.extend({
    defaults: {
      hasError: false,
    },
    getOption: Mn.proxyGetOption,
    initialize: function(attrs, options) {
      Backbone.Model.prototype.initialize.apply(this, arguments);
      this.options = _.extend({}, _.result(this, 'options'), options);
      this.listenTo(this.getOption('model'), 'validated', this.onModelValidated);
    },
    onModelValidated: function(model, isValid, validations) {
      var errors = this.getFieldErrors(validations);
      if (_.isEmpty(errors)) {
        this.set({
          hasError: false,
          errors: [],
          message: null,
        });
      } else {
        this.set({
          hasError: true,
          errors: errors,
          message: this.getAggregatedErrorMessage(errors),
        });
      }
    },
    clearErrors: function() {
      this.set({
        hasError: false,
        errors: [],
        message: null,
      });
      return this;
    },
    getAggregatedErrorMessage: function(errors) {
      return _.pluck(errors, 'message').join(' ');
    },
    getFieldErrors: function(errors) {
      var fieldName = this.getFieldName();
      if (!fieldName) {
        return [];
      }
      return _.filter(errors, function(error) {
        return _.result(error, 'field') === fieldName;
      });
    },
    getFieldName: function() {
      return this.getOption('fieldName');
    },
  });

  var ClearErrorsOnChangeValueBehavior = Mn.Behavior.extend({
    onFirstRender: function() {
      var errorStateModel = this.getOption('errorStateModel');
      if (!errorStateModel) {
        return;
      }

      this.listenTo(this.view, 'change:value', function() {
        errorStateModel.clearErrors();
      });
    },
  });

  var LabelComponentView = UIKit.ItemView.extend({
    className: 'field',

    options: {
      forElementId: '',
      size: null,
      inline: false,
      required: false,
      state: null,
      fieldName: null,
      errorStateModel: null,
      errorStateModelClass: ErrorStateModel,
    },

    template: Templates.FuKit['label.component.view'],

    getErrorStateModel: function() {
      var ErrorStateModel = this.getOption('errorStateModelClass');
      if (!this.errorStateModel) {
        //prettier-ignore
        var contentOptions  = Mn._getValue(this.getOption('content')),
                contentBindings = _.result(contentOptions, 'bindings');
        this.errorStateModel = new ErrorStateModel(
          {},
          {
            model: _.result(contentOptions, 'model') || this.getOption('model'),
            fieldName: this.getOption('fieldName') || _.result(contentBindings, 'value'),
          }
        );
      }
      return this.errorStateModel;
    },

    behaviors: function() {
      return {
        BindAndFormatOptionValuesBehavior: {
          optionValues: {
            state: {
              model: this.getErrorStateModel(),
              modelAttribute: 'hasError',
              formatter: function(hasError) {
                return hasError ? 'error' : null;
              },
            },
          },
          behaviorClass: BindAndFormatOptionValuesBehavior,
        },
      };
    },

    internalViewOptions: {
      labelView: ExtendUtil.extendOptionValueWithDefaults('label', function() {
        return {
          type: UIKit.Text,
          model: this.getOption('model'),
          forElementId: this.getOption('forElementId'),
        };
      }),
      contentView: ExtendUtil.extendOptionValueWithDefaults('content', function() {
        return {
          type: UIKit.Text.extend({
            formatter: Formatter.empty(),
          }),
          model: this.getOption('model'),
          behaviors: {
            ClearErrorsOnChangeValueBehavior: {
              errorStateModel: this.getErrorStateModel(),
              behaviorClass: ClearErrorsOnChangeValueBehavior,
            },
          },
        };
      }),
      errorView: ExtendUtil.extendOptionValueWithDefaults('error', function() {
        return {
          type: UIKit.Label,
          attributes: {
            style: 'display: block; width: 100%; text-align: center; padding: 1em; font-weight: normal;',
          },
          pointing: 'above',
          color: 'red',
          errorStateModel: this.getErrorStateModel(),
          behaviors: {
            BindAndFormatOptionValuesBehavior: {
              optionValues: {
                visible: {
                  model: this.getErrorStateModel(),
                  modelAttribute: 'hasError',
                },
                text: {
                  model: this.getErrorStateModel(),
                  formatter: function(model) {
                    return new Handlebars.SafeString(model.get('message'));
                  },
                },
              },
              behaviorClass: BindAndFormatOptionValuesBehavior,
            },
          },
        };
      }),
    },

    updateAttributes: function() {
      this.addClass(UIKit.Grid.getSizeClass(this.getOption('size')) + ' wide', this.getBoolOption('size'));
      this.addClass(this.getOption('state'), this.getBoolOption('state'));
      this.addClass('inline', this.getBoolOption('inline'));
      this.addClass('required', this.getBoolOption('required'));
    },
  });

  module.exports = LabelComponentView;
});

